<template>
  <div :id="source" :class="['flex flex-col items-center gap-2', padding]">
    <img :class="css" :src="computedImagePath" alt="empty_screen" />
    <span class="text_color text-base proxima_nova opacity-60 font-normal">{{ text }}</span>
  </div>
</template>

<script setup>
import empty_screen from '../../assets/images/empty_screen.svg';
import { computed } from 'vue';

const props = defineProps({
  source: { type: String, required: true },
  text: { type: String, default: 'No results found!' },
  css: { type: String, default: 'size-[72px]' },
  padding: { type: String, default: 'my-10' },
});

const computedImagePath = computed(() => {
  return empty_screen;
});
</script>
